import { DyTableColumn } from 'src/app/dynamic/model/dy-model';

export const TABLE_CONFIG_COLUMNS_TERMINALS: DyTableColumn[] = [
  {
    dataKey: 'actions',
    label: 'Action',
    width: 100,
    type: 'action',
    alignClass: 'text-start',
    actions: [
      {
        name: 'edit',
        iconName: 'pencil',
      },
    ],
  },
  { dataKey: 'terminalId', label: 'ID', width: 100, type: 'number' },
  { dataKey: 'name', label: 'Terminal Name', width: 200, type: 'text' },
  { dataKey: 'keySerialNumber', label: 'Serial Number', width: 100, type: 'number' },
  { dataKey: 'isActive', label: 'Status', width: 150, type: 'status' },
  // { dataKey: 'isSandbox', label: 'Sandbox', width: 100, type: 'status' },
];
